import { useEffect, useState } from 'react';
import { OriginIdentifier } from 'src/common/constants';
import { ZillowHomeLoansURL } from 'src/utils/ZillowHomeLoansURL';
import { DatadogCustomAction } from 'src/services/datadog/constants';
import { client } from 'src/services/datadog/client';
import { isCurrentRuntimeEnvironmentRedirectExempt } from '../utils/isCurrentRuntimeEnvironmentRedirectExempt';

/**
 * For most paths, we can redirect exactly the same. Exception to this rule being /login/dashboard which is permanently
 * sunset
 */
const getFinalDestinationForLoginDashboard = (path: string): string =>
    path.replace('/login/dashboard', '/mortgage/dashboard/login');

export const useMigrateToZillowState = () => {
    const [isRedirectDecisionMade, setIsRedirectDecisionMade] = useState(false);
    useEffect(() => {
        if (window.location.hostname.includes(OriginIdentifier.ZILLOW) || isCurrentRuntimeEnvironmentRedirectExempt()) {
            setIsRedirectDecisionMade(true);
            return;
        }
        const redirectToZillow = async () => {
            const [, relativePath] = window.location.href.split(window.location.hostname);
            const sanitizedRelativePath = getFinalDestinationForLoginDashboard(relativePath);

            const zillowEquivalentPath = new ZillowHomeLoansURL(sanitizedRelativePath).resolvedURL;
            await client.addAction(DatadogCustomAction.MIGRATION_REDIRECT, {
                from: relativePath,
                to: zillowEquivalentPath,
            });
            window.location.replace(zillowEquivalentPath);
        };
        redirectToZillow();
    }, []);

    return {
        isRedirectDecisionMade,
    };
};
